import { OnboardingGrid } from "apps/oneOnboarding/OnboardingGrid";
import { OneOnboardingSkeleton } from "apps/oneOnboarding/Skeleton";
import { SidebarSkeleton } from "apps/oneOnboarding/sidebar/Skeleton";

const Page = () => {
    return <OnboardingGrid sidebar={<SidebarSkeleton />} content={<OneOnboardingSkeleton />} />;
};

export default Page;
